// extracted by mini-css-extract-plugin
export default {"container":"container-module--container--4123e","isNarrow":"container-module--isNarrow--8e189","fadeIn":"container-module--fadeIn--05a54"};